export default "__VITE_ASSET__Cg_H6mEr__"